export { default } from "./Skeleton.mjs";
export * from "./skeletonClasses.mjs";
export { default as skeletonClasses } from "./skeletonClasses.mjs";